/* ============================================================================
   LOVI — LOT 22 (08/08/2026)
   Chargé en DERNIER par snippets/custom-code-body.liquid, après
   lovi-lot21.js. Auto-neutralisant : ne fait rien si la page ne contient
   pas de [data-lpdp-pack].

   Trois actions, toutes non destructrices :

   1. .lovi22-priceline — ENVELOPPE .lovi2-pk__price et .lovi2-pack__compare
      dans un même conteneur pour les poser sur une ligne de base commune
      (prix payé à gauche, prix de référence barré à droite). Les deux noeuds
      existants sont DÉPLACÉS, jamais recréés, jamais supprimés.
      .lovi2-pk__perbottle (« soit 17,45 € le flacon ») reste où il est.

   2. Prix de référence — le contenu de .lovi2-pack__compare est recopié
      EXCLUSIVEMENT depuis data-compare-text, qui vient du compare_at_price
      de la variante. Aucun montant n'est calculé, deviné ni fabriqué. Si
      data-compare-text est vide, le span est vidé et le CSS (:empty) le
      retire du flux : l'emplacement reste vide et la ligne se réduit.
      Mesuré le 08/08/2026 : les 3 variantes ont compare_at_price = null,
      donc les 3 emplacements sont vides aujourd'hui.

   3. Source de la vignette du palier 1 — bascule
      lovi-flacon-detoure-1182px.png (portrait 363x1182) vers
      lovi-pack-1-flacon-1200.png (carré 1200x1200), déjà dans
      Contenu > Fichiers. La référence de l'ancien fichier RESTE dans
      templates/page.lovi-drainage-pdp.json, hors usage, jamais supprimée :
      c'est pour cela que la bascule est faite ici et non dans le template.
      Le correctif reste juste même si cette bascule échoue : la règle de
      recadrage de lovi-lot22.css est gardée par [src*="lovi-pack-"], donc
      une source portrait garde le rendu du lot 18 (flacon 75,9 px) et les
      sources carrées sont recadrées à 76,0 px — écart 0,1 px dans les deux
      états.

   Aucun hook réécrit : data-lpdp-pack, data-variant-id, data-gifts,
   data-unlock, data-price-text, data-compare-text, .is-selected,
   .is-locked, __loviAtcPrice et packs[idx].click() sont intacts.
   ============================================================================ */
(function () {
  'use strict';

  var OLD_SRC = 'lovi-flacon-detoure-1182px.png';
  var NEW_SRC = 'lovi-pack-1-flacon-1200.png';

  /* 3. bascule de la source carrée sur le palier 1 ------------------------- */
  function swapPackImage(pack) {
    var img = pack.querySelector('img.lovi2-pk__img');
    if (!img) return;
    var src = img.getAttribute('src') || '';
    if (src.indexOf(OLD_SRC) === -1) return;
    // srcset/sizes retirés : ils repointeraient vers l'ancien fichier
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src.replace(OLD_SRC, NEW_SRC));
  }

  /* 1. + 2. ligne de prix -------------------------------------------------- */
  function buildPriceLine(pack) {
    var price = pack.querySelector('.lovi2-pk__price');
    var cmp = pack.querySelector('.lovi2-pack__compare');
    if (!price || !cmp) return;

    var line = pack.querySelector('.lovi22-priceline');
    if (!line) {
      line = document.createElement('span');
      line.className = 'lovi22-priceline';
      price.parentNode.insertBefore(line, price);
      line.appendChild(price);   // déplacé, pas recréé
      line.appendChild(cmp);     // déplacé, pas recréé
    }

    // Prix de référence : uniquement ce que Shopify a réellement renseigné.
    var txt = (pack.getAttribute('data-compare-text') || '').trim();
    if (txt) {
      if (cmp.textContent.trim() !== txt) cmp.textContent = txt;
    } else if (cmp.textContent !== '') {
      cmp.textContent = '';      // pas de placeholder, pas de calcul
    }
  }

  /* Typographie française : espace insécable avant le symbole euro.
     Restreint à deux classes qui ne sont PAS des hooks — on ne touche pas
     .lovi2-pk__price, relu par le script du buybox. Corrige le « € »
     orphelin en début de ligne dans « valeur 4,90 € · OFFERT ». */
  function hardSpaceEuro(root) {
    var nodes = root.querySelectorAll('.lovi2-gift__value, .lovi2-pk__perbottle');
    for (var i = 0; i < nodes.length; i++) {
      var kids = nodes[i].childNodes;
      for (var j = 0; j < kids.length; j++) {
        var n = kids[j];
        if (n.nodeType !== 3) continue;
        // U+0020 espace, U+00A0 insecable, U+202F insecable fine -> U+00A0
        var v = n.nodeValue.replace(/[   ]€/g, ' €');
        if (v !== n.nodeValue) n.nodeValue = v;
      }
    }
  }

  function run() {
    var packs = document.querySelectorAll('[data-lpdp-pack]');
    if (!packs.length) return;                 // auto-neutralisant
    for (var i = 0; i < packs.length; i++) {
      swapPackImage(packs[i]);
      buildPriceLine(packs[i]);
    }
    hardSpaceEuro(document);
  }

  run();

  /* Ré-application après un clic sur un palier : le buybox réécrit le prix
     et les cadeaux. run() est idempotent (il ne réenveloppe pas deux fois). */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-lpdp-pack]')) setTimeout(run, 60);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }
  window.addEventListener('load', run);
})();
